import { css, FlattenSimpleInterpolation } from 'styled-components';

const fontFamily = 'Inter var, Inter, sans-serif';

export type TypographyName =
  | 'superHeader'
  | 'H1'
  | 'H2'
  | 'H3'
  | 'body'
  | 'cell'
  | 'label'
  | 'inputLabel'
  | 'caption';
export type Typography = {
  [name in TypographyName]: FlattenSimpleInterpolation;
};

/* Unfortunately the styled components babel plugin does not automatically
 * add PURE annotation for the `css` function :(
 */

export const typography: Typography = {
  superHeader: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 42px;
    line-height: 51px;
    font-weight: bold;
    letter-spacing: -0.04em;
  `,
  H1: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 32px;
    letter-spacing: -0.04em;
    line-height: 40px;
  `,
  H2: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 20px;
    letter-spacing: -0.012em;
    line-height: 30px;
  `,
  H3: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 16px;
    letter-spacing: -0.011em;
    line-height: 19px;
  `,
  body: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 16px;
    letter-spacing: -0.011em;
    line-height: 1.5;
  `,
  cell: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 13px;
    letter-spacing: -0.003em;
    line-height: 16px;
    font-feature-settings: 'tnum' 1;
  `,
  label: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 12px;
    letter-spacing: 0.06em;
    line-height: 15px;
    text-transform: uppercase;
  `,
  inputLabel: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 10px;
    letter-spacing: 0.09em;
    line-height: 12px;
    text-transform: uppercase;
  `,
  caption: /*#__PURE__*/ css`
    font-family: ${fontFamily};
    font-size: 10px;
    line-height: 14px;
  `,
};
